export const ALERTS = {
  SUCCESS: "Success",
  ERROR: "Error",
  INFO: "Info",
  WARNING: "Warning",
  ERRORS: {
    CLIENT_NOT_FOUND_ERROR: "Client not found",
    NETWORK_ERROR: "Network error",
  },
};

export const FETCH = {
  CONTENT_TYPE: {
    VALUE: "Content-Type",
    JSON: "application/json",
  },
};

export const CREATE = "create";

// For SearchableSelect CB Component usage
export const SELECT_ALL = "Select All";
